export const appendDateToCopyright = (string: string | undefined) => {
  const thisYear = String(new Date().getFullYear());

  const footerTitle = string?.replace(/[0-9]/g, "");

  return (
    footerTitle?.split(" ")[0] +
    " " +
    thisYear +
    footerTitle?.substring(footerTitle.split(" ")[0].length)
  );
};
